export enum LanguageCode {
    EN = 'en',
    DE = 'de',
    FR = 'fr',
    IT = 'it'
}

export const LANGUAGE_FLAGS: { [key in LanguageCode]: string } = {
    [LanguageCode.EN]: 'assets/images/GB.svg',
    [LanguageCode.DE]: 'assets/images/DE.svg',
    [LanguageCode.FR]: 'assets/images/FR.svg',
    [LanguageCode.IT]: 'assets/images/IT.svg',
};

export const LANGUAGES = [
    { code: LanguageCode.EN, name: 'English' },
    { code: LanguageCode.DE, name: 'Deutsch' },
    { code: LanguageCode.FR, name: 'French' },
    { code: LanguageCode.IT, name: 'Italian' },
];
